import $ from "jquery"

const video = () => {
	if (document.querySelector(".js-video")) {
		// Video
		const youtubeParser = (url) => {
			const regExp =
				/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([^\s&?\/]+)/
			const match = url.match(regExp)
			return match && match[1].length === 11 ? match[1] : false
		}

		const video = `${youtubeParser(
			$("#youtubeVideo").find("iframe").attr("data-video")
		)}?amp;iv_load_policy=3&amp;listType=user_uploads&amp;controls=1&amp;fs=0&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`
		$("#youtubeVideo")
			.find("iframe")
			.attr("src", `https://www.youtube.com/embed/${video}`)
	}
}

export default video
